import React, { Fragment } from "react";
import { Alert, Form, Radio, Input, Button, Row, Col } from "antd";
import { CheckCircleOutlined, CloudUploadOutlined } from "@ant-design/icons";
import SelectTemplate from "./CampainComps/SelectTemplate";
import { ROW_GUTTER } from "constants/ThemeConstant";
import ConditionalRender from "../Utils/ConditionalRender";
import { useNavigate } from "react-router-dom";

const TemplateComponent = ({
  showTemplateType,
  templateName,
  templateCategory,
  setTemplateCategory,
  templateList,
  HandleTemplate,
  template,
  mediaType,
  showMediaModel,
  mediaLink,
  buttonStyle,
  mediaName,
  setMediaLink,
  templateInputs,
  templateUrlInputs, // New prop for handling URL inputs
  ResetState,
  setLocation,
  location,
  hideBodyInputs, // true in Excel mode — inputs come from Excel, not manual entry
  module,
}) => {
  const navigate = useNavigate();
  const [templateType, setTemplateType] = React.useState("normal");

  return (
    <Fragment>
      {showTemplateType && (
        <Form.Item label="Template Type">
          <Radio.Group
            value={templateType}
            onChange={(e) => {
              const val = e.target.value;
              if (val === "carousel") {
                navigate("/carousel/campaign");
              } else {
                setTemplateType(val);
              }
            }}
          >
            <Radio value="normal">Normal</Radio>
            <Radio value="carousel">Carousel</Radio>
          </Radio.Group>
        </Form.Item>
      )}

      {(!showTemplateType || templateType === "normal") && (
        <>
          <Row gutter={ROW_GUTTER}>
            <Col span={8}>
              <Form.Item label="Template Category" name="Template_category">
                <Radio.Group
                  onChange={(e) => {
                    setTemplateCategory(e.target.value);
                    ResetState && ResetState();
                  }}
                  value={templateCategory}
                >
                  <Radio value="MARKETING">Marketing</Radio>
                  <Radio value="UTILITY">Utility</Radio>
                </Radio.Group>
                <span className="d-none">{templateCategory}</span>
              </Form.Item>
            </Col>

            <ConditionalRender condition={templateCategory}>
              <Col span={8}>
                <Form.Item
                  label="Templates"
                  name="Templates"
                >
                  <SelectTemplate
                    templateName={templateName}
                    HandleTemplate={HandleTemplate}
                    templateList={templateList}
                  />
                  <span className="d-none">{templateName}</span>
                </Form.Item>
              </Col>

              <ConditionalRender
                condition={template?.header && template?.header?.format !== "TEXT"}
              >
                <ConditionalRender
                  condition={template?.header?.format === "LOCATION"}
                  truthyContent={
                    <Col span={24}>
                      <Row gutter={ROW_GUTTER}>
                        <Col span={12}>
                          <Form.Item
                            label="Latitude"
                            name="location-latitude"
                            rules={[
                              {
                                required: true,
                                message: "Please enter latitude!",
                              },
                            ]}
                          >
                            <Input
                              type="number"
                              step="any"
                              placeholder="e.g., 37.7749"
                              value={location?.latitude}
                              onChange={(e) =>
                                setLocation({ ...location, latitude: e.target.value })
                              }
                            />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item
                            label="Longitude"
                            name="location-longitude"
                            rules={[
                              {
                                required: true,
                                message: "Please enter longitude!",
                              },
                            ]}
                          >
                            <Input
                              type="number"
                              step="any"
                              placeholder="e.g., -122.4194"
                              value={location?.longitude}
                              onChange={(e) =>
                                setLocation({ ...location, longitude: e.target.value })
                              }
                            />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item
                            label="Location Name (Optional)"
                            name="location-name"
                          >
                            <Input
                              type="text"
                              placeholder="e.g., Our Office"
                              value={location?.name}
                              onChange={(e) =>
                                setLocation({ ...location, name: e.target.value })
                              }
                            />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item label="Address (Optional)" name="location-address">
                            <Input.TextArea
                              placeholder="e.g., 123 Main St, City, State"
                              autoSize={{ minRows: 2, maxRows: 4 }}
                              value={location?.address}
                              onChange={(e) =>
                                setLocation({ ...location, address: e.target.value })
                              }
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Col>
                  }
                  falsyContent={
                    // Media Header - Handle IMAGE/VIDEO/DOCUMENT
                    <ConditionalRender
                      condition={mediaType === "Media"}
                      truthyContent={
                        <Col span={8}>
                          <Form.Item label="Select media" name="media-link">
                            <ConditionalRender
                              condition={!mediaLink}
                              truthyContent={
                                <Button
                                  type=""
                                  style={buttonStyle}
                                  onClick={showMediaModel}
                                >
                                  <CloudUploadOutlined />
                                  Choose File
                                </Button>
                              }
                              falsyContent={
                                <>
                                  {/* <Input
                                    type="text"
                                    disabled
                                    value="Media Selected"
                                    className="mb-3"
                                  /> */}
                                  <Button
                                    type=""
                                    style={buttonStyle}
                                    onClick={showMediaModel}
                                  >
                                    <CloudUploadOutlined />
                                    Choose Another File
                                  </Button>
                                  <div style={{ marginTop: 8, display: 'flex', alignItems: 'center', gap: 6, color: '#52c41a' }}>
                                    <CheckCircleOutlined style={{ fontSize: 16 }} />
                                    <span style={{ fontSize: 13 }}>Media selected</span>
                                  </div>
                                </>
                              }
                            />
                          </Form.Item>
                        </Col>
                      }
                      falsyContent={
                        <Form.Item
                          label="Your media file link"
                          name="media-link"
                          rules={[
                            {
                              required: true,
                              message: "Please enter media file link!",
                            },
                          ]}
                        >
                          <Input
                            type="text"
                            onChange={(e) => setMediaLink(e.target.value)}
                            className="mb-3"
                          />
                        </Form.Item>
                      }
                    />
                  }
                />
              </ConditionalRender>
              <Col span={24}>
                {templateInputs.length > 0 &&
                  (hideBodyInputs ? (
                    <Alert
                      className="mb-3"
                      type="success"
                      showIcon
                      message={`${templateInputs.length} variable(s) detected — values will be read from your Excel file`}
                      description={`Your Excel file must have ${templateInputs.length + 1
                        } columns total: Column 1 = Mobile Number, then ${templateInputs.length
                        } variable column(s) in columns 2–${templateInputs.length + 1
                        }.`}
                    />
                  ) : (
                    <Form.Item
                      label={`${templateInputs.length} dynamic values detected`}
                    >
                      <Row gutter={ROW_GUTTER}>
                        {templateInputs.map((input, index) => (
                          <Col span={6} key={index} className="mb-2">
                            {input}
                          </Col>
                        ))}
                      </Row>
                    </Form.Item>
                  ))}
              </Col>

              {/* Handling templateUrlInputs */}
              <div>
                {templateUrlInputs.length > 0 && (
                  <Form.Item
                    label={`${templateUrlInputs.length} Url Button detected`}
                  >
                    {templateUrlInputs.map((input, index) => (
                      <div key={index} className="mb-2">
                        {input}
                      </div>
                    ))}
                  </Form.Item>
                )}
              </div>
            </ConditionalRender>
          </Row>
        </>
      )}
    </Fragment>
  );
};

export default TemplateComponent;

